import Modal from '../modal/modal'
import { bodyElement } from '../common/body-element'
import { type Nullable } from '../../types/common'
import { PopupStorage } from './popup-storage'
import { PopupType } from './types'

class PopupAgeVerifier extends Modal {
  storage: PopupStorage

  constructor () {
    super()
    this.storage = new PopupStorage(this.dataset.blockId ?? this.id)
  }

  connectedCallback (): void {
    const data = this.storage.loadData()

    if (this.isEditorMode) {
      this.editor.subscribe('BLOCK_SELECT', this._handleBlockSelect)
      this.editor.subscribe('BLOCK_DESELECT', this._handleBlockDeselect)
      return
    }

    if (!data || (data.type === PopupType.AgeVerifier && !data.verified)) {
      this.show()
    }
  }

  disconnectedCallback (): void {
    if (this.isEditorMode) {
      this.editor.destroy()
    }
  }

  _handleBlockSelect = ({ detail: { blockId } }): void => {
    if (this.dataset.blockId === blockId) {
      this.show()
    }
  }

  _handleBlockDeselect = ({ detail: { blockId } }): void => {
    if (this.dataset.blockId === blockId) {
      this.hide()
    }
  }

  prepareGradient = (gradient: string, opacity: string): string => {
    try {
      const colors = gradient.match(/rgba\([^()]*\)|#\w+/g)

      colors?.forEach(color => {
        const [r, g, b, a] = color.split('(')[1].split(')')[0].split(',').map(c => c.trim())

        const alpha = +a * +opacity

        gradient = gradient.replace(color, `rgba(${r}, ${g}, ${b}, ${Math.round(alpha * 100) / 100})`)
      })

      return gradient
    } catch (e) {
      return gradient
    }
  }

  async show (): Promise<void> {
    const withGradient = !!this.dataset.overlayGradient

    const background = withGradient ? this.prepareGradient(this.dataset.overlayGradient, this.dataset.overlayOpacity) : `color-mix(in srgb, ${this.dataset.overlaySolid} ${this.dataset.overlayOpacity * 100}%, transparent)`

    bodyElement.showOverlay(this.id, { zIndex: 5, background, backdropFilter: `blur(${this.dataset.overlayBlur}px)`, transitionDuration: '0s' })

    await super.show()
    this._verifyBtn?.addEventListener('click', this.onVerify)
  }

  async hide (): Promise<void> {
    bodyElement.hideOverlay(this.id)
    await super.hide()
  }

  onVerify = (): void => {
    if (!this.isEditorMode) {
      this.storage.saveData({ type: PopupType.AgeVerifier, verified: true })
    }
    this._verifyBtn?.removeEventListener('click', this.onVerify)
    this.hide()
  }

  get _verifyBtn (): Nullable<HTMLElement> {
    if (!this.isOpen) {
      return null
    }

    return this.querySelector('[data-verify-btn]')
  }
}

export default PopupAgeVerifier
